// C:\Users\Fabrice PINTON\Desktop\monitoring\main-app\src\App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import ProtectedRoute from './ProtectedRoute';
import RedirectManager from './RedirectManager';
import LoginPage from './LoginPage';
// Supprimez l'import de MonthlyPollutionReport

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Route pour la page de connexion */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Route pour le gestionnaire de redirection */}
          <Route 
            path="/redirect/:affaireId" 
            element={
              <ProtectedRoute>
                <RedirectManager />
              </ProtectedRoute>
            } 
          />
          
          {/* Redirection par défaut vers la page de connexion */}
          <Route path="/" element={<Navigate to="/login" />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;